import { useBoolVariation } from '@launchdarkly/react-sdk'
import Layout from '@views/Layout/Layout'
import LayoutOld from '@views/Layout/LayoutOld'

/**
 * Wrapper/helper to handle rendering the correct layout based on the feature flag.
 * This can stay when the feature flag is fully rolled out.
 *
 * Note: when the FF is removed, delete the LayoutOld and SidebarOld folders/files
 */
export default function LayoutManager() {
	const uiUpdateEnabled = useBoolVariation('feature-art-1553-new-ui-layout', false)

	if (uiUpdateEnabled) {
		return <Layout />
	}
	return <LayoutOld />
}
